import { AppEnvironment, appEnvironment } from 'utils/env'
import { isTenantSmava } from 'utils/url'
import {
  ffgClientDetails,
  smavaClientDetails
} from './getClientDetails.constants'

export const getClientDetails = () => {
  if (isTenantSmava()) {
    return (
      // @ts-ignore - clientDetailsSmava type needs refinement for dynamic access
      smavaClientDetails[appEnvironment] ||
      smavaClientDetails[AppEnvironment.Shared]
    )
  }

  return (
    // @ts-ignore - clientDetailsFinanzcheck type needs refinement for dynamic access
    ffgClientDetails[appEnvironment] || ffgClientDetails[AppEnvironment.Shared]
  )
}
